import { exportToWord } from '../utils/exportToWord'; // Import the export function
import './PolicyStyles.css'; // Ensure the correct path to your CSS file

const BreakdownAndRecoveryProcedure = ({ clientName, clientAddress, effectiveDate,  companyNumber, }) => {
  return (
    <div className="policy-container">
      <h3 className="policy-title">Accident & Incident Management Policy</h3>
      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> { companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">Purpose</h4>
      <p className="section-content">
        The purpose of this procedure is to ensure that all drivers and employees understand the process to follow in the event of a breakdown or recovery. This procedure aims to minimize downtime and ensure safe and efficient recovery operations.
      </p>

      <h4 className="section-title">Scope</h4>
      <p className="section-content">
        This procedure applies to all vehicles operated by the company, including HGVs, PSVs, and any other company-owned vehicles. It covers all breakdown and recovery situations, including mechanical failures, accidents, and any other circumstances that require the vehicle to be towed or recovered.
      </p>

      <h4 className="section-title">Responsibilities</h4>
      <p className="section-content"><strong>Drivers:</strong> Drivers are responsible for following the breakdown procedure, ensuring their safety, and reporting the issue to the appropriate contacts. Drivers must ensure that their vehicle is secured before contacting recovery services.</p>
      <p className="section-content"><strong>Transport Managers:</strong> Transport Managers are responsible for coordinating recovery services, ensuring the vehicle is recovered promptly, and maintaining accurate records of the incident.</p>
      <p className="section-content"><strong>Fleet Maintenance Team:</strong> The Fleet Maintenance Team will work with recovery services to diagnose the problem, arrange for repairs if needed, and ensure the vehicle is brought back into operation as quickly as possible.</p>

      <h4 className="section-title">Breakdown Procedure</h4>
      <p className="section-content">
        In the event of a vehicle breakdown, the following steps must be followed:
      </p>
      <ul>
        <li>Ensure safety: If the vehicle is on the road, activate hazard lights immediately, move the vehicle to a safe location if possible, and ensure all occupants are safe.</li>
        <li>Contact the Transport Manager or designated contact: Inform them of the breakdown, including the location, nature of the issue, and any immediate safety concerns.</li>
        <li>Assess the situation: If the issue is minor (e.g., flat tyre), attempt to resolve the problem safely. If the vehicle cannot be repaired quickly, initiate recovery procedures.</li>
        <li>Call for recovery: Contact the recovery service and provide them with accurate information about the location and nature of the breakdown. Be ready to provide any necessary details (e.g., vehicle make/model, registration number).</li>
      </ul>

      <h4 className="section-title">Recovery Procedure</h4>
      <p className="section-content">
        The following steps should be taken when recovery is required:
      </p>
      <ul>
        <li>Recovery service response: The recovery service will assess the situation and arrange for the vehicle to be towed to an appropriate location (e.g., repair garage, depot).</li>
        <li>Provide assistance: Ensure the driver and any other personnel are safely removed from the vehicle and transported to a safe location if needed.</li>
        <li>Documentation: Record the details of the breakdown, recovery service used, and any damage or issues discovered during the recovery. This should be logged for future reference and insurance purposes.</li>
      </ul>

      <h4 className="section-title">After Breakdown/Recovery</h4>
      <p className="section-content">
        Once the vehicle has been recovered, the following steps should be followed:
      </p>
      <ul>
        <li>Inspection: The vehicle should be thoroughly inspected to determine the cause of the breakdown and assess if any damage occurred during the recovery process.</li>
        <li>Repairs: If necessary, arrange for repairs and ensure that the vehicle is returned to safe working condition before it is put back into operation.</li>
        <li>Reporting: Ensure the breakdown is reported and logged into the company’s maintenance records for analysis and future prevention of similar incidents.</li>
        <li>Review: After the incident, a review should be conducted to evaluate the cause of the breakdown, recovery time, and any improvements that can be made to prevent future breakdowns.</li>
      </ul>

      <h4 className="section-title">Emergency Contact Information</h4>
      <p className="section-content">
        The following contact numbers should be used in the event of a breakdown or recovery:
      </p>
      <ul>
        <li>Transport Manager: [Insert Contact Number]</li>
        <li>24/7 Recovery Service: [Insert Contact Number]</li>
        <li>Fleet Maintenance Team: [Insert Contact Number]</li>
      </ul>

      <h4 className="section-title">Record Keeping</h4>
      <p className="section-content">
        A record of all breakdowns and recoveries must be maintained, including the following details:
      </p>
      <ul>
        <li>Date and time of breakdown.</li>
        <li>Location of the vehicle.</li>
        <li>Cause of the breakdown (if known).</li>
        <li>Details of the recovery service used.</li>
        <li>Any damage caused during the breakdown or recovery process.</li>
        <li>Time taken to recover the vehicle.</li>
      </ul>

      <h4 className="section-title">Conclusion</h4>
      <p className="section-content">
        The breakdown and recovery procedure ensures that the company’s vehicles are recovered safely and efficiently, minimizing disruption to operations. All employees involved in the process must follow this procedure to maintain safety, operational continuity, and compliance with the company’s standards.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I have read, understood, and agree to comply with the Breakdown and Recovery Procedure. I understand my responsibilities in the event of a breakdown or recovery situation.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is hereby in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>
    </div>
  );
};

export default BreakdownAndRecoveryProcedure;
